
<template>
  <div class="services">

    <div id="our-services" class="our-services"></div>

    <!-- TITLE -->
    <h1 class="service-heading">MikMak Services</h1>
    <Blob></Blob>
    <div class="service-wrapper">

      <div v-for="service in List" class="service-item-block">
        <h1 v-html="service.name"></h1>
        <h3 v-html="service.text"></h3>

        <span class="bullet-item" v-for="bullet in service.bullets" v-html="`&middot; ${bullet}`"></span>

        <div class="video-wrapper" v-if="service.videoUrl">
          <img class="video-device" src="../../../assets/winter-2019/hero-phone-16.png">
          <video class="video-element" :src="service.videoUrl" muted playsinline autoplay loop></video>
        </div>


        <a href="#contact-footer" type="button" name="button" v-html="service.buttonText"></a>
      </div>

    </div>

  </div>
</template>

<script>

import Blob from './blob'

export default {
  data() {
    return {
      List: [
        // {
        //   name: 'MikMak Studios',
        //   icon: '',
        //   iconClass: '',
        //   bullets: [
        //     'Full-service video production & post-production',
        //     'Content strategy & creative development',
        //     'Social media content creation',
        //     'Product video creation',
        //     'A/B video production tests'
        //   ],
        //   buttonText: 'Request a quote',
        //   videoUrl: 'https://s3.amazonaws.com/attach-videos/KrLJi9lkTyCIbPNT0TCQ_reel-sm-framerate.mov',
        //   text: 'Full-service production specialized in fun, short-form product videos.'
        // },
        {
          name: 'MikMak Academy',
          icon: '',
          iconClass: '',
          bullets: [
            'How-To and 101\'s',
            'Creative best practices',
            'Competitive deep dives',
            'Building a social commerce & media strategy',
            'C-Suite series'
          ],
          buttonText: 'Enroll in a course',
          text: 'Immersive, custom-designed courses to upskill brands for success in the rapidly evolving world of social video commerce. Courses include:'
        }
      ]
    }
  },
  components: {
    Blob
  },
  mounted() {
    // if (!window.sr) window.sr = ScrollReveal()
    // window.sr.reveal('.services', { delay: 250, duration: 500 })
  },
  methods: {},
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .services {
    display: block;
    margin: 32px 0;
    margin-top: -40px;
  }

  .our-services {
    height: 80px;
  }

  .service-heading {
    font-family: "Work Sans",sans-serif;
    font-weight: normal;
    letter-spacing: 2px;
    font-size: 14px;
    margin: 0 auto;
    display: block;
    text-align: center;
    color: #333;
    text-transform: uppercase;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .-wrapper {
    display: block;
    margin: 24px auto;
    text-align: center;
  }

  .service-item-block {
    text-decoration: none;
    width: 45%;
    vertical-align: top;
    margin: 24px auto;
    text-align: center;
    font-family: "Work Sans", sans-serif;
    font-size: 18px;
    color: #fff;
    transition: ease-in-out 0.225s;
    /* background: rgba(255, 255, 255, 0.45); */
    padding: 24px 0;
    border-radius: 2px;
  }

  .service-item-block h1 {
    /* background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%); */
    /* -webkit-background-clip: text; */
    /* -webkit-text-fill-color: transparent; */
    color: #333;
    padding: 0px;
    margin: 0px;
    font-weight: normal;
    font-size: 28px;
    font-family: 'Raleway', sans-serif;
  }

  .service-item-block h3 {
    padding: 0px;
    margin: 4px;
    font-weight: normal;
    color: #333;
    font-size: 16px;
  }


  .service-item-block a {
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    color: #fff;
    font-size: 22px;
    text-decoration: none;
    cursor: pointer;
    min-width: 224px;
    max-width: 300px;
    text-align: center;
    padding: 8px;
    border-radius: 3px;
    margin: 24px auto;
    display: block;
    cursor: pointer;
    box-shadow: 0 2px 6px #00000024;
    font-weight: lighter;
    text-decoration: none;
    letter-spacing: 1px;
    border: none;
  }

  @media only screen and (max-width: 800px) {
    .service-item-block {
      width: 90%;
    }
  }

  .icon {
    font-style: normal;
    font-size: 45px;
    position: absolute;
    margin-top: -16px;
    margin-left: -48px;
    transform: rotate(-6deg);
    text-shadow: 0 1px 15px rgba(0, 0, 0, 0.22);
  }

  .icon-1 {

  }

  .icon-2 {

  }

  .icon-3 {

  }

  .icon-4 {
    font-size: 55px;
    margin-top: -22px;
  }

  .icon-5 {

  }

  .icon-6 {

  }

  .icon-7 {

  }

  .icon-8 {

  }

  .service-name {
    width: 229px;
    font-size: 16px;
    display: inline-block;
  }

  .video-wrapper {
    display: block;
    width: 100%;
    text-align: center;
  }

  .video-device {
    width: 280px;
    position: absolute;
    margin-left: -43px;
    pointer-events: none;
  }

  .video-element {
    width: 197px;
    margin: 52px auto;
    margin-left: -2px;
  }

  .bullet-item {
    display: block;
    color: #a09f9f;
    margin: 12px;
  }

</style>



// WEBPACK FOOTER //
// Services.vue?18b01771